export default "__VITE_ASSET__Cy34kkCS__"